import { useGame } from '@/store/game';

/**
 * Партия закончена. Итогов нет и не будет: победителя, очков и достижений в
 * игре не существует — компания просто решила, что хватит.
 *
 * После `finish` сервер закрывает соединение и освобождает код комнаты, так
 * что «ещё раз» — это новая комната, а не возврат в старую: `reset()` рвёт
 * транспорт и забывает код.
 */
export function FinishedScreen() {
  const state = useGame((s) => s.state);
  const closedReason = useGame((s) => s.closedReason);
  const reset = useGame((s) => s.reset);

  const players = state ? [...state.players].sort((a, b) => a.seat - b.seat) : [];

  return (
    <div
      className="flex min-h-screen flex-col bg-ground px-5 text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)', paddingBottom: 'var(--clown-safe-bottom)' }}
    >
      <div className="flex-1 py-6">
        <h1 className="font-display text-display">ВСЁ</h1>
        <p className="mt-3 text-lead text-dim">
          {state ? `Партия шла ${state.turn} ходов.` : 'Партия завершена.'} Победителей нет —
          так задумано.
        </p>

        <ul className="mt-6 flex flex-col gap-rule border-2 border-line bg-line">
          {players.map((p) => (
            <li key={p.id} className="flex h-row items-center bg-panel px-4">
              <span className="min-w-0 flex-1 truncate text-row">{p.name}</span>
            </li>
          ))}
        </ul>

        {closedReason && <p className="mt-3 text-base text-mute">{closedReason}</p>}
      </div>

      <button
        type="button"
        onClick={reset}
        className="flex h-act w-full items-center justify-center bg-acc font-display text-btn uppercase text-ground"
      >
        Новая партия
      </button>
    </div>
  );
}
